<template>
  <div class="faq landing-wrapper">
    <div class="faq-wrapper">
      <h2 class="faq-title landing-title">{{ $t('faq.title') }}</h2>

      <div class="faq-content">
        <GradientCard
          v-for="(item, index) in items"
          :key="`faq-${index}`"
          class="faq-card"
          inner-class="faq-card__wrapper"
        >
          <img class="faq-card__icon" :src="item.icon" alt="banner" />
          <div class="faq-card__info">
            <div class="faq-card__title">{{ item.title }}</div>
            <div class="faq-card__description">{{ item.description }}</div>
          </div>

          <Button
            v-if="index === 0"
            size="sm"
            type="secondary"
            class="faq-card__subscribe"
            left-icon="/base/email.svg"
            @click="redirectTo(item.link)"
          >
            {{ $t('faq.items.item1.button') }}
          </Button>

          <Button v-if="index === 1" size="xl" class="faq-card__more" @click="$router.push(item.link)">
            {{ $t('faq.items.item2.button') }}
          </Button>
        </GradientCard>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Base/Button/Button.vue'
import GradientCard from '@/components/GradientCard/GradientCard.vue'

import social from '@/mixins/social'

export default {
  name: 'Faq',
  mixins: [social],

  components: { GradientCard, Button },
  computed: {
    items() {
      return [
        {
          title: this.$t('faq.items.item1.title'),
          description: this.$t('faq.items.item1.content'),
          icon: require('@/assets/images/faq/icon-1.svg'),
          link: this.tgUrl
        },
        {
          title: this.$t('faq.items.item2.title'),
          description: this.$t('faq.items.item2.content'),
          icon: require('@/assets/images/faq/icon-2.svg'),
          link: '/transfer'
        },
        {
          title: this.$t('faq.items.item3.title'),
          description: this.$t('faq.items.item3.content'),
          icon: require('@/assets/images/faq/icon-3.svg')
        }
      ]
    }
  },
  methods: {
    redirectTo(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss">
@import './faq';
</style>
